/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const c = 'is-current';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 52
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');
			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}
				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});
						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;
				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						const savedPos = window.scrollY;
						focusableElements[0].focus({ preventScroll: true });
						window.scrollTo({ top: savedPos });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					if (!/#/.test(e.currentTarget.href)) return;
					const url = new URL(e.currentTarget.href, location.href);
					// 別ページへの遷移はデフォルト動作に任せる
					if (url.pathname !== location.pathname) return;
					e.preventDefault();
					scrollToObject(e);
					let hash = e.currentTarget.href.split('#')[1];
					await waitForScrollComplete(hash);
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					// # を除去して純粋な ID 文字列にする
					const id = _hash.replace(/^#/, '');
					if (id !== 'pagetop') {
						const target = document.getElementById(id);
						if (!target) return;
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							target.querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							const savedPos = window.scrollY;
							focusableElements[0].focus({ preventScroll: true });
							window.scrollTo({ top: savedPos });
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				// ブラウザ既定のアンカースクロールを抑制（display:none フラッシュ回避）
				if ('scrollRestoration' in history) {
					history.scrollRestoration = 'manual';
				}
				window.addEventListener('load', async () => {
					window.scrollTo(0, 0);
					const targetId = hash.replace(/^#/, '');
					const targetEl = document.getElementById(targetId);
					if (!targetEl) return;
					let pos = targetEl.getBoundingClientRect().top + window.scrollY;
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos -= FUNCTIONS.va.header.sp;
					} else {
						pos -= FUNCTIONS.va.header.desktop;
					}
					window.scrollTo({ top: pos, behavior: 'smooth' });
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');
			if ($pagetop) {
				$pagetop.classList.add('is-anim');
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);
				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener('keydown', function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === 'Tab') {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === 'Escape') {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#close"></use></svg>';
						$content.appendChild(closeButton);
						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));
						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});
			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><svg aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#close"></use></svg></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();
			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化
			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			target.forEach(ele => ele.classList.add('is-animSet'));
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);
			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		inViewAnimation2() {
			const target = document.querySelectorAll('.js-fade-head');
			target.forEach(ele => ele.classList.add('is-animSet'));
			const options = {
				root: null,
				rootMargin: '0px 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);
			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		nextToggle() {
			const switchElements = document.querySelectorAll('.js-toggle');
			switchElements.forEach(switchElement => {
				switchElement.classList.add('is-animSet');
			});
			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', e => {
					const target = e.currentTarget;
					target.classList.toggle(a);
					const toggleBlock = target.nextElementSibling;
					if (toggleBlock) {
						toggleBlock.classList.toggle(a);
						if (toggleBlock.style.height) {
							toggleBlock.style.height = null;
							toggleBlock.style.visibility = 'hidden';
							toggleBlock.style.opacity = '0';
						} else {
							toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
							toggleBlock.style.visibility = 'visible';
							toggleBlock.style.opacity = '1';
						}
					}
				});
			});
			// リサイズ時に開いているトグルブロックの高さを再計算
			let resizeTimer;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(() => {
					switchElements.forEach(switchElement => {
						const toggleBlock = switchElement.nextElementSibling;
						if (toggleBlock && toggleBlock.style.height && toggleBlock.style.height !== '0px') {
							toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						}
					});
				}, 300);
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if(document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		URLcurrentHidden() {
			if (document.querySelector('.js-currentHidden')) {
				document.querySelectorAll('.js-currentHidden').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、親要素のjs-currentHidden-wrapにdi_noneを追加
					if (currentPath == linkPath) {
						const parentWrap = item1.closest('.js-currentHidden-wrap');
						parentWrap.classList.add('di_none');
					}
				});
			}
		},
		URLcurrentDirectory3Hidden() {
			if (document.querySelector('.js-currentDirectory3Hidden')) {
				document.querySelectorAll('.js-currentDirectory3Hidden').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 第3階層のディレクトリを取得
					const currentPathParts = currentPath.split('/').filter(part => part);
					const linkPathParts = linkPath.split('/').filter(part => part);
					// 第3階層のディレクトリが一致する場合、親要素のjs-currentDirectory3Hidden-wrapにdi_noneを追加
					if (currentPathParts.length > 1 && linkPathParts.length > 1 && currentPathParts[1] === linkPathParts[1]) {
						const parentWrap = item1.closest('.js-currentDirectory3Hidden-wrap');
						if (parentWrap) {
							parentWrap.classList.add('di_none');
						}
					}
				});
			}
		},
		URLcurrentDirectory4Hidden() {
			if (document.querySelector('.js-currentDirectory4Hidden')) {
				document.querySelectorAll('.js-currentDirectory4Hidden').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 第4階層のディレクトリを取得
					const currentPathParts = currentPath.split('/').filter(part => part);
					const linkPathParts = linkPath.split('/').filter(part => part);
					// 第4階層のディレクトリが一致する場合、親要素のjs-currentDirectory4Hidden-wrapにdi_noneを追加
					if (currentPathParts.length > 2 && linkPathParts.length > 2 && currentPathParts[2] === linkPathParts[2]) {
						const parentWrap = item1.closest('.js-currentDirectory4Hidden-wrap');
						if (parentWrap) {
							parentWrap.classList.add('di_none');
						}
					}
				});
			}
		},
		headerMegamenu() {
			if (document.querySelectorAll('.js-header-nav').length) {
				const $header = document.querySelector('.header');
				const $nav = document.querySelector('.header-nav');
				const $headerNavMain = document.querySelector('.header-nav-main');
				const $headerNavOtherMenu = document.querySelector('.header-nav-other-menu');
				const $megabtn = document.querySelectorAll('.js-header-nav-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-contents');
				const $megaSubbtn = document.querySelectorAll('.js-header-nav-sub-btn');
				const $megaSubmenu = document.querySelectorAll('.js-header-nav-sub-contents');
				const $megaClose = document.querySelectorAll('.js-header-nav-close');
				const $searchBtn = document.querySelector('.js-header-search');
				const $searchContents = document.querySelector('.js-header-search-contents');
				const $searchClose = document.querySelectorAll('.js-header-search-close');
				let previousWindowWidth = window.innerWidth;
				const isDesktopView = () => window.innerWidth > FUNCTIONS.va.device.desktop;
				const isSpView = () => !isDesktopView();
				const getControlledMenu = (button, selector) => {
					if (!button) {
						return null;
					}
					const controlsId = button.getAttribute('aria-controls');
					if (!controlsId) {
						return null;
					}
					const targetMenu = document.getElementById(controlsId);
					if (!targetMenu || !targetMenu.matches(selector)) {
						return null;
					}
					return targetMenu;
				};
				const setLowerWrapTopFromMainTtl = (button) => {
					if (!$megaSubmenu.length) {
						return;
					}
					const controlledMainMenu = getControlledMenu(button, '.js-header-nav-contents');
					if (!controlledMainMenu) {
						return;
					}
					const mainTtl = controlledMainMenu.querySelector('.header-nav-main-contents-ttl');
					if (!mainTtl) {
						return;
					}
					const topValue = mainTtl.offsetHeight + FUNCTIONS.va.header.desktop;
					$megaSubmenu.forEach((submenu) => {
						submenu.style.top = `${topValue}px`;
					});
				};
				// ハンバーガーやメニュークローズ時はスライドクラスをリセット
				function resetNavSlide() {
					$nav.classList.remove('is-slide-main', 'is-slide-sub');
				}
				if ($searchBtn) $searchBtn.addEventListener('click', resetNavSlide);
				$searchClose.forEach(btn => btn.addEventListener('click', resetNavSlide));
				$megaClose.forEach(btn => btn.addEventListener('click', resetNavSlide));
				// メニュー閉じる処理
				const closeAllMegaMenus = () => {
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						btn.setAttribute('aria-expanded', 'false');
						const megaNav = getControlledMenu(btn, '.js-header-nav-contents');
						if (megaNav) {
							megaNav.classList.remove(a);
						}
					});
					$megaSubbtn.forEach(btn => {
						btn.classList.remove(a);
						btn.setAttribute('aria-expanded', 'false');
						const subNav = getControlledMenu(btn, '.js-header-nav-sub-contents');
						if (subNav) {
							subNav.classList.remove(a);
						}
					});
					document.querySelectorAll('.header-nav-main-contents-inner').forEach(menu => {
						menu.style.height = '';
					});
					$megaSubmenu.forEach(menu => {
						menu.style.height = '';
					});
					if ($searchContents && $searchBtn) {
						$searchContents.classList.remove(a);
						$searchBtn.setAttribute('aria-expanded', 'false');
					}
				};
				const resetSubMenus = () => {
					$megaSubbtn.forEach(btn => {
						btn.classList.remove(a);
						btn.setAttribute('aria-expanded', 'false');
						const subNav = getControlledMenu(btn, '.js-header-nav-sub-contents');
						if (subNav) {
							subNav.classList.remove(a);
							subNav.style.height = '';
						}
					});
					document.querySelectorAll('.header-nav-main-contents-inner').forEach(menu => {
						menu.style.height = '';
					});
				};
				// メインメニューボタンのクリックイベント処理
				$megabtn.forEach(btn => {
					btn.addEventListener('click', (e) => {
						const clickedBtn = e.currentTarget;
						const clickedNav = getControlledMenu(clickedBtn, '.js-header-nav-contents');
						setLowerWrapTopFromMainTtl(clickedBtn);
						const isAlreadyOpen = clickedBtn.classList.contains(a);
						resetSubMenus();
						// スマートフォン時にスライドクラスを付与
						if (isSpView()) {
							$nav.classList.add('is-slide-main');
						}
						// 検索メニューを閉じる処理
						if ($searchContents && $searchContents.classList.contains(a)) {
							$searchContents.classList.remove(a);
							$searchBtn.setAttribute('aria-expanded', 'false');
						}
						if (isDesktopView()) {
							// 他のメインメニューを閉じる
							$megabtn.forEach(otherBtn => {
								const otherNav = getControlledMenu(otherBtn, '.js-header-nav-contents');
								otherBtn.classList.remove(a);
								otherBtn.setAttribute('aria-expanded', 'false');
								if (otherNav) {
									otherNav.classList.remove(a);
								}
							});
						}
						if (!isAlreadyOpen && clickedNav) {
							$header.classList.add(a);
							clickedBtn.classList.add(a);
							clickedBtn.setAttribute('aria-expanded', 'true');
							clickedNav.classList.add(a);
						} else {
							$header.classList.remove(a);
							clickedBtn.classList.remove(a);
							clickedBtn.setAttribute('aria-expanded', 'false');
							if (clickedNav) {
								clickedNav.classList.remove(a);
							}
						}
					});
				});
				// サブメニューボタンのクリックイベント処理
				$megaSubbtn.forEach(btn => {
					btn.addEventListener('click', (e) => {
						const clickedBtn = e.currentTarget;
						const clickedNav = getControlledMenu(clickedBtn, '.js-header-nav-sub-contents');
						const isAlreadyOpen = clickedNav && clickedNav.classList.contains(a);
						const mainContentsMenu = clickedBtn.closest('.header-nav-main-contents').querySelector('.header-nav-main-contents-inner');
						// スマートフォン時にスライドクラスを付与
						if (isSpView()) {
							$nav.classList.add('is-slide-sub');
						}
						// 他のサブメニューを閉じる
						$megaSubbtn.forEach(otherBtn => {
							const otherNav = getControlledMenu(otherBtn, '.js-header-nav-sub-contents');
							otherBtn.classList.remove(a);
							otherBtn.setAttribute('aria-expanded', 'false');
							if (otherNav) {
								otherNav.classList.remove(a);
								otherNav.style.height = '';
							}
						});
						if (isDesktopView()) {
							if (mainContentsMenu) {
								mainContentsMenu.style.height = '';
							}
						}
						if (!isAlreadyOpen && clickedNav) {
							clickedBtn.classList.add(a);
							clickedBtn.setAttribute('aria-expanded', 'true');
							clickedNav.classList.add(a);
							// サブメニューのinner要素の高さを取得してメインメニューに適用
							if (isDesktopView()) {
								if (mainContentsMenu) {
									const subMenuInner = clickedNav.querySelector('.header-nav-sub-contents-wrap');
									if (subMenuInner) {
										const subMenuHeight = subMenuInner.offsetHeight;
										const mainMenuHeight = mainContentsMenu.offsetHeight;
										// サブメニューの高さがメインメニューより大きい場合のみ適用
										if (subMenuHeight > mainMenuHeight) {
											clickedNav.style.height = `${subMenuHeight}px`;
											mainContentsMenu.style.height = `${subMenuHeight}px`;
										}
									}
								}
							}
						}
					});
				});
				// 検索機能のクリックイベント処理
				if ($searchBtn && $searchContents) {
					$searchBtn.addEventListener('click', () => {
						const isSearchActive = $searchContents.classList.contains(a);
						if (isSearchActive) {
							$searchContents.classList.remove(a);
							$searchBtn.setAttribute('aria-expanded', 'false');
						} else {
							closeAllMegaMenus();
							$searchContents.classList.add(a);
							$searchBtn.setAttribute('aria-expanded', 'true');
						}
					});
					$searchClose.forEach(btn => {
						btn.addEventListener('click', () => {
							$searchContents.classList.remove(a);
							$searchBtn.setAttribute('aria-expanded', 'false');
						});
					});
				}
				// メニュー外のクリックでメニューを閉じる
				document.addEventListener('click', (event) => {
					const target = event.target;
					const isClickInsideNav = [...$megamenu, ...$megaSubmenu].some(el => el && el.contains(target));
					const isClickOnButton = [...$megabtn, ...$megaSubbtn].some(btn => btn && btn.contains(target));
					const isClickInsideSearch = $searchContents && $searchContents.contains(target);
					const isClickOnSearchButton = $searchBtn && $searchBtn.contains(target);
					// メニューも検索メニューも開いていない、かつ、クリックした場所がメニューでもボタンでも検索要素でもない場合
					if (
						!isClickInsideNav && !isClickOnButton &&
						!isClickInsideSearch && !isClickOnSearchButton &&
						$header.classList.contains(a)
					) {
						closeAllMegaMenus();
						$header.classList.remove(a);
					}
				});
				// 閉じるボタンのクリックイベント処理
				$megaClose.forEach(btn => {
					btn.addEventListener('click', (e) => {
						e.preventDefault();
						closeAllMegaMenus();
						$header.classList.remove(a);
						const $closedMenu = btn.closest('.js-header-nav-contents');
						if ($closedMenu) {
							const $targetBtn = document.querySelector(`.js-header-nav-btn[aria-controls="${$closedMenu.id}"]`);
							if ($targetBtn && $targetBtn.classList.contains('js-header-nav-btn')) {
								$targetBtn.focus({ preventScroll: true }); 
							}
						}
					});
				});
				// 戻るボタンのクリックイベント処理
				const $prevBtns = document.querySelectorAll('.js-prev-btn');
				$prevBtns.forEach(btn => {
					btn.addEventListener('click', (e) => {
						e.preventDefault();
						if (isSpView()) {
							if ($nav.classList.contains('is-slide-sub')) {
								$nav.classList.remove('is-slide-sub');
							} else if ($nav.classList.contains('is-slide-main')) {
								$nav.classList.remove('is-slide-main');
							}
						}
						const subParent = btn.closest('.js-header-nav-sub-contents');
						const mainParent = btn.closest('.js-header-nav-contents');
						if (subParent) {
							subParent.classList.remove(a);
							const subParentBtn = document.querySelector(`.js-header-nav-sub-btn[aria-controls="${subParent.id}"]`);
							if (subParentBtn) {
								subParentBtn.classList.remove(a);
								subParentBtn.setAttribute('aria-expanded', 'false');
							}
							const parentMainMenu = mainParent || (subParentBtn ? subParentBtn.closest('.js-header-nav-contents') : null);
							if (parentMainMenu) {
								parentMainMenu.classList.add(a);
								const mainParentBtn = document.querySelector(`.js-header-nav-btn[aria-controls="${parentMainMenu.id}"]`);
								if (mainParentBtn) {
									mainParentBtn.classList.add(a);
									mainParentBtn.setAttribute('aria-expanded', 'true');
								}
								$header.classList.add(a);
							}
							return;
						}
						// メインメニューの戻る時のみis-activeを削除
						if (mainParent) {
							mainParent.classList.remove(a);
							const mainParentBtn = document.querySelector(`.js-header-nav-btn[aria-controls="${mainParent.id}"]`);
							if (mainParentBtn) {
								mainParentBtn.classList.remove(a);
								mainParentBtn.setAttribute('aria-expanded', 'false');
							}
							$header.classList.remove(a);
						}
					});
				});
				// フォーカスが外れた時のメニュー制御
				$megabtn.forEach(btn => {
					const menu = getControlledMenu(btn, '.js-header-nav-contents');
					if (isDesktopView()) {
						if (menu) {
							// フォーカスが該当メガメニュー内にあるかチェックする関数
							const isInsideMegaMenu = (element) => {
								if (!element) {
									return false;
								}
								if (menu.contains(element) || btn.contains(element)) {
									return true;
								}
								const isInsideActiveSubMenu = [...$megaSubmenu].some((subMenu) => {
									return subMenu.classList.contains(a) && subMenu.contains(element);
								});
								const isInsideActiveSubButton = [...$megaSubbtn].some((subBtn) => {
									return subBtn.classList.contains(a) && subBtn.contains(element);
								});
								return isInsideActiveSubMenu || isInsideActiveSubButton;
							};
							const closeMegaMenuByFocusOut = () => {
								if (!isDesktopView()) {
									return;
								}
								btn.classList.remove(a);
								btn.setAttribute('aria-expanded', 'false');
								menu.classList.remove(a);
								resetSubMenus();
								// 全てのメガメニューが閉じられているかチェック
								const hasOpenMenu = [...$megabtn].some(b => b.classList.contains(a));
								if (!hasOpenMenu) {
									$header.classList.remove(a);
								}
							};
							// フォーカスが外れた時にメニューを閉じる
							menu.addEventListener('focusout', () => {
								if (!isDesktopView()) {
									return;
								}
								setTimeout(() => {
									if (!isDesktopView()) {
										return;
									}
									const focusedElement = document.activeElement;
									// 該当メガメニュー外にフォーカスが移動した場合に閉じる
									if (!isInsideMegaMenu(focusedElement)) {
										closeMegaMenuByFocusOut();
									}
								}, 0);
							});
							// TabキーまたはShift+Tabで移動した際にメニューを閉じる
							menu.addEventListener('keydown', (e) => {
								if (e.key === 'Tab') {
									if (!isDesktopView()) {
										return;
									}
									setTimeout(() => {
										if (!isDesktopView()) {
											return;
										}
										const focusedElement = document.activeElement;
										// 該当メガメニュー外にフォーカスが移動した場合に閉じる
										if (!isInsideMegaMenu(focusedElement)) {
											closeMegaMenuByFocusOut();
										}
									}, 0);
								}
							});
						}
					}
				});
				// フォーカスの順序をメニュー構造に合わせる関数
				const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
				const getFocusableElements = (container) => {
					if (!container) {
						return [];
					}
					return Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
						const style = window.getComputedStyle(element);
						return element.offsetParent !== null && style.display !== 'none' && style.visibility !== 'hidden';
					});
				};
				const getHeaderFocusOrder = () => {
					return getFocusableElements($headerNavMain);
				};
				const getControlledFirstFocusable = (triggerElement) => {
					if (!triggerElement) {
						return null;
					}
					if (triggerElement.classList.contains('js-header-nav-sub-btn')) {
						const parentMainMenu = triggerElement.closest('.js-header-nav-contents');
						if (!parentMainMenu || !parentMainMenu.classList.contains(a)) {
							return null;
						}
						const controlledSubMenu = getControlledMenu(triggerElement, '.js-header-nav-sub-contents');
						if (!controlledSubMenu) {
							return null;
						}
						if (!controlledSubMenu.classList.contains(a)) {
							$megaSubbtn.forEach((otherBtn) => {
								const otherNav = getControlledMenu(otherBtn, '.js-header-nav-sub-contents');
								otherBtn.classList.remove(a);
								otherBtn.setAttribute('aria-expanded', 'false');
								if (otherNav) {
									otherNav.classList.remove(a);
									otherNav.style.height = '';
								}
							});
							triggerElement.classList.add(a);
							triggerElement.setAttribute('aria-expanded', 'true');
							controlledSubMenu.classList.add(a);
						}
						const controlledFocusables = getFocusableElements(controlledSubMenu);
						return controlledFocusables.length ? controlledFocusables[0] : null;
					}
					const controlsId = triggerElement.getAttribute('aria-controls');
					if (!controlsId) {
						return null;
					}
					const controlledElement = document.getElementById(controlsId);
					if (!controlledElement) {
						return null;
					}
					const isExpanded = triggerElement.getAttribute('aria-expanded') === 'true' || controlledElement.classList.contains(a);
					if (!isExpanded) {
						return null;
					}
					const controlledFocusables = getFocusableElements(controlledElement);
					return controlledFocusables.length ? controlledFocusables[0] : null;
				};
				const focusNextMainButtonFromActiveMainMenu = (activeMainMenu) => {
					if (!activeMainMenu) {
						return false;
					}
					const currentMainBtn = document.querySelector(`.js-header-nav-btn[aria-controls="${activeMainMenu.id}"]`);
					if (!currentMainBtn) {
						return false;
					}
					const mainFocusables = getFocusableElements($headerNavMain);
					const currentIndex = mainFocusables.indexOf(currentMainBtn);
					if (currentIndex === -1) {
						return false;
					}
					for (let i = currentIndex + 1; i < mainFocusables.length; i++) {
						const nextFocusable = mainFocusables[i];
						if (!nextFocusable) {
							continue;
						}
						activeMainMenu.classList.remove(a);
						currentMainBtn.classList.remove(a);
						currentMainBtn.setAttribute('aria-expanded', 'false');
						resetSubMenus();
						const hasOpenMenu = [...$megabtn].some((btn) => btn.classList.contains(a));
						if (!hasOpenMenu) {
							$header.classList.remove(a);
						}
						nextFocusable.focus({ preventScroll: true });
						return true;
					}
					return false;
				};
				const getParentMainMenuFromSubMenu = (activeSubMenu) => {
					if (!activeSubMenu) {
						return null;
					}
					const currentSubBtn = document.querySelector(`.js-header-nav-sub-btn[aria-controls="${activeSubMenu.id}"]`);
					if (!currentSubBtn) {
						return null;
					}
					return currentSubBtn.closest('.js-header-nav-contents');
				};
				const focusNextInParentMainAfterSubMenu = (activeSubMenu) => {
					if (!activeSubMenu) {
						return false;
					}
					const currentSubBtn = document.querySelector(`.js-header-nav-sub-btn[aria-controls="${activeSubMenu.id}"]`);
					if (!currentSubBtn) {
						return false;
					}
					const parentMainMenu = currentSubBtn.closest('.js-header-nav-contents');
					if (!parentMainMenu) {
						return false;
					}
					activeSubMenu.classList.remove(a);
					activeSubMenu.style.height = '';
					currentSubBtn.classList.remove(a);
					currentSubBtn.setAttribute('aria-expanded', 'false');
					const mainFocusables = getFocusableElements(parentMainMenu);
					const currentIndex = mainFocusables.indexOf(currentSubBtn);
					if (currentIndex === -1) {
						return false;
					}
					for (let i = currentIndex + 1; i < mainFocusables.length; i++) {
						const nextFocusable = mainFocusables[i];
						if (!nextFocusable) {
							continue;
						}
						nextFocusable.focus({ preventScroll: true });
						return true;
					}
					return false;
				};
				const closeFocusedMainMenuBySubMenu = (activeSubMenu) => {
					if (!activeSubMenu) {
						return;
					}
					activeSubMenu.classList.remove(a);
					activeSubMenu.style.height = '';
					const currentSubBtn = document.querySelector(`.js-header-nav-sub-btn[aria-controls="${activeSubMenu.id}"]`);
					if (currentSubBtn) {
						currentSubBtn.classList.remove(a);
						currentSubBtn.setAttribute('aria-expanded', 'false');
					}
					const activeMainMenu = [...$megamenu].find((menu) => menu.classList.contains(a));
					if (activeMainMenu) {
						activeMainMenu.classList.remove(a);
						const currentMainBtn = document.querySelector(`.js-header-nav-btn[aria-controls="${activeMainMenu.id}"]`);
						if (currentMainBtn) {
							currentMainBtn.classList.remove(a);
							currentMainBtn.setAttribute('aria-expanded', 'false');
						}
					}
					resetSubMenus();
					const hasOpenMenu = [...$megabtn].some((btn) => btn.classList.contains(a));
					if (!hasOpenMenu) {
						$header.classList.remove(a);
					}
				};
				const moveHeaderFocusByOrder = (event) => {
					if (!isDesktopView() || event.key !== 'Tab' || !$header) {
						return;
					}
					const activeElement = document.activeElement;
					if (!activeElement || !$header.contains(activeElement)) {
						return;
					}
					if (!event.shiftKey) {
						const activeMainMenu = activeElement.closest('.js-header-nav-contents');
						if (activeMainMenu && activeMainMenu.classList.contains(a)) {
							const mainMenuFocusables = getFocusableElements(activeMainMenu);
							const lastFocusableInMain = mainMenuFocusables[mainMenuFocusables.length - 1];
							if (lastFocusableInMain && activeElement === lastFocusableInMain) {
								event.preventDefault();
								if (focusNextMainButtonFromActiveMainMenu(activeMainMenu)) {
									return;
								}
							}
						}
					}
					if (!event.shiftKey) {
						const activeSubMenu = activeElement.closest('.js-header-nav-sub-contents');
						if (activeSubMenu && activeSubMenu.classList.contains(a)) {
							const subMenuFocusables = getFocusableElements(activeSubMenu);
							const lastFocusable = subMenuFocusables[subMenuFocusables.length - 1];
							if (lastFocusable && activeElement === lastFocusable) {
								event.preventDefault();
								if (focusNextInParentMainAfterSubMenu(activeSubMenu)) {
									return;
								}
								const parentMainMenu = getParentMainMenuFromSubMenu(activeSubMenu);
								if (parentMainMenu && focusNextMainButtonFromActiveMainMenu(parentMainMenu)) {
									return;
								}
								closeFocusedMainMenuBySubMenu(activeSubMenu);
								return;
							}
						}
					}
					if (!event.shiftKey) {
						const controlledFirstFocusable = getControlledFirstFocusable(activeElement);
						if (controlledFirstFocusable) {
							event.preventDefault();
							controlledFirstFocusable.focus({ preventScroll: true });
							return;
						}
					}
					const order = getHeaderFocusOrder();
					if (!order.length) {
						return;
					}
					const currentIndex = order.indexOf(activeElement);
					if (currentIndex === -1) {
						return;
					}
					const nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;
					if (nextIndex < 0 || nextIndex >= order.length) {
						return;
					}
					event.preventDefault();
					order[nextIndex].focus({ preventScroll: true });
				};
				$header.addEventListener('keydown', moveHeaderFocusByOrder);
				window.addEventListener('resize', () => {
					const currentWindowWidth = window.innerWidth;
					if (currentWindowWidth === previousWindowWidth) {
						return;
					}
					previousWindowWidth = currentWindowWidth;
					closeAllMegaMenus();
					resetNavSlide();
					$header.classList.remove(a);
				});
				// ESCキーでメニューを閉じる
				window.addEventListener('keydown', function (event) {
					if (event.key === 'Escape') {
						const isHeaderActive = $header.classList.contains(a);
						const isSearchActive = $searchContents && $searchContents.classList.contains(a);
						if (isHeaderActive || isSearchActive) {
							event.preventDefault();
							closeAllMegaMenus();
							$header.classList.remove(a);
						}
					}
				});
			}
			if (document.querySelectorAll('.js-header-business-select-btn').length) {
				const $businessContents = document.querySelector('.js-header-business-select-contents');
				const $businessBtns = document.querySelectorAll('.js-header-business-select-btn');
				const $businessCloses = document.querySelectorAll('.js-header-business-select-close');
				$businessBtns.forEach((btn) => {
					const $businessBtn = btn;
					if ($businessBtn && $businessContents) {
						// クリックイベント
						$businessBtn.addEventListener('click', () => {
							const isActive = $businessContents.classList.contains(a);
							if (isActive) {
								$businessContents.classList.remove(a);
								$businessBtn.setAttribute('aria-expanded', 'false');
							} else {
								$businessBtns.forEach((ele) => {
									ele.setAttribute('aria-expanded', 'false');
								});
								$businessContents.classList.add(a);
								$businessBtn.setAttribute('aria-expanded', 'true');
							}
						});
					}
				});
				// 閉じるボタンのクリックイベント（複数対応）
				if ($businessContents && $businessCloses.length) {
					$businessCloses.forEach(($businessClose) => {
						$businessClose.addEventListener('click', (e) => {
							e.preventDefault();
							const activeBusinessBtn = Array.from($businessBtns).find((ele) => ele.getAttribute('aria-expanded') === 'true');
							$businessContents.classList.remove(a);
							$businessBtns.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
							(activeBusinessBtn || $businessBtns[0]).focus({ preventScroll: true });
						});
					});
				}
				// ESCキーで閉じる処理
				if ($businessContents) {
					window.addEventListener('keydown', (event) => {
						if (event.key === 'Escape' && $businessContents.classList.contains(a)) {
							event.preventDefault();
							$businessContents.classList.remove(a);
							$businessBtns.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
						}
					});
				}
			}
			if (document.querySelectorAll('.js-header-business-select-btn1').length) {
				const $businessContents1 = document.querySelector('.js-header-business-select-contents1');
				const $businessBtns1 = document.querySelectorAll('.js-header-business-select-btn1');
				const $businessCloses1 = document.querySelectorAll('.js-header-business-select-contents1-close');
				$businessBtns1.forEach((btn) => {
					const $businessBtn1 = btn;
					if ($businessBtn1 && $businessContents1) {
						// クリックイベント
						$businessBtn1.addEventListener('click', () => {
							const isActive = $businessContents1.classList.contains(a);
							if (isActive) {
								$businessContents1.classList.remove(a);
								$businessBtn1.setAttribute('aria-expanded', 'false');
							} else {
								$businessBtns1.forEach((ele) => {
									ele.setAttribute('aria-expanded', 'false');
								});
								$businessContents1.classList.add(a);
								$businessBtn1.setAttribute('aria-expanded', 'true');
							}
						});
					}
				});
				// 閉じるボタンのクリックイベント（複数対応）
				if ($businessContents1 && $businessCloses1.length) {
					$businessCloses1.forEach(($businessClose1) => {
						$businessClose1.addEventListener('click', (e) => {
							e.preventDefault();
							const activeBusinessBtn1 = Array.from($businessBtns1).find((ele) => ele.getAttribute('aria-expanded') === 'true');
							$businessContents1.classList.remove(a);
							$businessBtns1.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
							(activeBusinessBtn1 || $businessBtns1[0]).focus({ preventScroll: true });
						});
					});
				}
				// ESCキーで閉じる処理
				if ($businessContents1) {
					window.addEventListener('keydown', (event) => {
						if (event.key === 'Escape' && $businessContents1.classList.contains(a)) {
							event.preventDefault();
							$businessContents1.classList.remove(a);
							$businessBtns1.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
						}
					});
				}
			}
			if (document.querySelectorAll('.js-header-business-select-btn2').length) {
				const $businessContents2 = document.querySelector('.js-header-business-select-contents2');
				const $businessBtns2 = document.querySelectorAll('.js-header-business-select-btn2');
				const $businessCloses2 = document.querySelectorAll('.js-header-business-select-contents2-close');
				$businessBtns2.forEach((btn) => {
					const $businessBtn2 = btn;
					if ($businessBtn2 && $businessContents2) {
						// クリックイベント
						$businessBtn2.addEventListener('click', () => {
							const isActive = $businessContents2.classList.contains(a);
							if (isActive) {
								$businessContents2.classList.remove(a);
								$businessBtn2.setAttribute('aria-expanded', 'false');
							} else {
								$businessBtns2.forEach((ele) => {
									ele.setAttribute('aria-expanded', 'false');
								});
								$businessContents2.classList.add(a);
								$businessBtn2.setAttribute('aria-expanded', 'true');
							}
						});
					}
				});
				// 閉じるボタンのクリックイベント（複数対応）
				if ($businessContents2 && $businessCloses2.length) {
					$businessCloses2.forEach(($businessClose2) => {
						$businessClose2.addEventListener('click', (e) => {
							e.preventDefault();
							const activeBusinessBtn2 = Array.from($businessBtns2).find((ele) => ele.getAttribute('aria-expanded') === 'true');
							$businessContents2.classList.remove(a);
							$businessBtns2.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
							(activeBusinessBtn2 || $businessBtns2[0]).focus({ preventScroll: true });
						});
					});
				}
				// ESCキーで閉じる処理
				if ($businessContents2) {
					window.addEventListener('keydown', (event) => {
						if (event.key === 'Escape' && $businessContents2.classList.contains(a)) {
							event.preventDefault();
							$businessContents2.classList.remove(a);
							$businessBtns2.forEach((ele) => {
								ele.setAttribute('aria-expanded', 'false');
							});
						}
					});
				}
			}
		},
		headerCurrent() {
			const currentPath = location.pathname;
			const getControlledMenu = (button, selector) => {
				if (!button) {
					return null;
				}
				const controlsId = button.getAttribute('aria-controls');
				if (!controlsId) {
					return null;
				}
				const targetMenu = document.getElementById(controlsId);
				if (!targetMenu || !targetMenu.matches(selector)) {
					return null;
				}
				return targetMenu;
			};
			// メガメニューがあるボタンのカレント処理
			if (document.querySelectorAll('.js-header-nav-btn').length) {
				const $megabtn = document.querySelectorAll('.js-header-nav-btn');
				$megabtn.forEach(btn => {
					const menu = getControlledMenu(btn, '.js-header-nav-contents');
					if (menu) {
						// メニュー内のすべてのリンクを取得
						const menuLinks = menu.querySelectorAll('a[href]');
						let isCurrentSection = false;
						menuLinks.forEach(link => {
							const linkHref = link.getAttribute('href');
							if (linkHref && linkHref.startsWith('/')) {
								// リンクのパスを正規化（末尾のindex.htmlを削除、末尾のスラッシュで統一）
								const linkPath = linkHref.replace(/index\.html$/, '').replace(/\/$/, '') + '/';
								const normalizedCurrentPath = currentPath.replace(/index\.html$/, '').replace(/\/$/, '') + '/';
								// 現在のパスがリンクのパス配下にある場合
								if (normalizedCurrentPath.startsWith(linkPath) && linkPath !== '/') {
									isCurrentSection = true;
								}
							}
						});
						// カレントセクションの場合、is-currentクラスを追加
						if (isCurrentSection) {
							btn.classList.add(c);
						} else {
							btn.classList.remove(c);
						}
					}
				});
			}
			// メガメニューがない単一リンクのカレント処理
			const $singleLinks = document.querySelectorAll('.header-nav-main-btn:not(.js-header-nav-btn)');
			$singleLinks.forEach(link => {
				const linkHref = link.getAttribute('href');
				if (linkHref && linkHref.startsWith('/')) {
					// リンクのパスを正規化（末尾のindex.htmlを削除、末尾のスラッシュで統一）
					const linkPath = linkHref.replace(/index\.html$/, '').replace(/\/$/, '') + '/';
					const normalizedCurrentPath = currentPath.replace(/index\.html$/, '').replace(/\/$/, '') + '/';
					// 現在のパスがリンクのパス配下にある場合
					if (normalizedCurrentPath.startsWith(linkPath) && linkPath !== '/') {
						link.classList.add(c);
					} else {
						link.classList.remove(c);
					}
				}
			});
		},
		headerHamburger() {
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $hamburgerLabel = $hamburger.querySelector('.__label');
				const $nav = document.querySelector('.header-nav');
				const $container = document.querySelector('.container');
				let previousWindowWidth = window.innerWidth;
				let scrollTopNow;
				const fixedOnContainer = () => {
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					$container.querySelector('.contents').style.opacity = '0';
				};
				const fixedOffContainer = () => {
					$container.style.position = 'static';
					$container.querySelector('.contents').style.opacity = '1';
					window.scrollTo({ top: scrollTopNow });
				};
				$hamburger.addEventListener('click', (e) => {
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.setAttribute('aria-expanded', 'false');
						$hamburger.ariaLabel = 'open'
						if ($hamburgerLabel) {
							$hamburgerLabel.textContent = 'MENU';
						}
						// SPスライドクラスもリセット
						$nav.classList.remove('is-slide-main', 'is-slide-sub');
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburger.setAttribute('aria-expanded', 'true');
						$hamburger.ariaLabel = 'close'
						if ($hamburgerLabel) {
							$hamburgerLabel.textContent = 'CLOSE';
						}
					}
				});
				window.addEventListener('resize', () => {
					const currentWindowWidth = window.innerWidth;
					if (currentWindowWidth === previousWindowWidth) {
						return;
					}
					previousWindowWidth = currentWindowWidth;
					$nav.classList.remove(a);
					$hamburger.classList.remove(a);
					$hamburger.setAttribute('aria-expanded', 'false');
					$hamburger.ariaLabel = 'open'
					if ($hamburgerLabel) {
						$hamburgerLabel.textContent = 'MENU';
					}
					fixedOffContainer();
				});
				window.addEventListener('keydown', function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === 'Tab') {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => {
									// 表示されている要素のみを対象とする
									const style = window.getComputedStyle(el);
									return el.offsetParent !== null && 
											style.display !== 'none' && 
											style.visibility !== 'hidden' &&
											el.tabIndex !== -1;
								});
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーでメニューを閉じる
						if (event.key === 'Escape') {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'close'
							if ($hamburgerLabel) {
								$hamburgerLabel.textContent = 'MENU';
							}
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});
			}
		},
		scrollHint() {
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp && document.querySelectorAll('.js-scrollable, .mod-tblWrap').length) {
				new ScrollHint('.js-scrollable, .mod-tblWrap', {
					suggestiveShadow: false,
					// remainingTime: 3000,
					i18n: {
						scrollable: 'スクロール<br>できます'
					}
				});
			}
		},
		topicsSlider() {
			const splides = document.querySelectorAll('.js-topics-slider');
			splides.forEach(slideElement => {
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoplay: true,
					interval: 5000, // 自動再生の間隔
					speed: 2000, // スライダーの移動時間
					focus: 'center',
					// perPage: 1,
					perMove: 1,
					gap: '16px',
					clones: 6,
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: false,
					autoWidth: true,
					updateOnMove: true,
					cloneStatus: false,
					breakpoints: {
						1024: {
							gap: '16px',
						},
					}
				});
				// スライドを中央に配置する関数
				function centerSlide() {
					const containerWidth = slideElement.offsetWidth;
					const activeSlide = slideElement.querySelector('.splide__slide.is-active');
					if (activeSlide) {
						const activeWidth = activeSlide.offsetWidth;
						const offset = (containerWidth - (640 / 2)) / 2;
						splide.options.focus = offset;
					}
				}
				// 各スライダー内のインデックス表示要素を取得
				const currentElement = slideElement.querySelector('.slide-current');
				const lengthElement = slideElement.querySelector('.slide-length');
				function slideIndex() {
					if (currentElement && lengthElement) {
						// 複製を除いたオリジナルのスライド数を取得
						const slides = splide.Components.Slides.get();
						const originalSlides = slides.filter(slide => !slide.isClone);
						const totalOriginal = originalSlides.length;
						// 現在のインデックスを計算（複製の場合は対応するオリジナルのインデックスを取得）
						let currentIndex = splide.index;
						if (splide.Components.Slides.getAt(currentIndex).isClone) {
							currentIndex = splide.Components.Slides.getAt(currentIndex).slideIndex;
						}
						const current = String(currentIndex + 1).padStart(2, '0');
						const total = String(totalOriginal).padStart(2, '0');
						currentElement.textContent = current;
						lengthElement.textContent = total;
					}
				}
				splide.on('mounted', function () {
					centerSlide();
					splide.refresh();
				});
				splide.on('move', slideIndex);
				splide.mount();
				slideIndex();
			});
		},
		slider01() {
			const splideEls = document.querySelectorAll('.js-slider01');
			splideEls.forEach(slide => {
				const splide = new Splide(slide, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 3,
					perMove: 1,
					gap: '40px',
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: true,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: '16px',
						},
					},
					classes: {
						arrows: 'splide__arrows mod-splide-arrows',
						arrow: 'splide__arrow mod-splide-arrow',
						prev: 'splide__arrow--prev mod-splide-prev',
						next: 'splide__arrow--next mod-splide-next',
						pagination: 'splide__pagination mod-splide-pagination',
						page: 'splide__pagination__page mod-splide-pagination-page',
					},
				});
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.mount();
			});
		},
		slider02() {
			const splideEls = document.querySelectorAll('.js-slider02');
			splideEls.forEach(slide => {
				const splide = new Splide(slide, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 3,
					perMove: 1,
					gap: '40px',
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: false,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: '24px',
						},
					},
					classes: {
						arrows: 'splide__arrows mod-splide-arrows',
						arrow: 'splide__arrow mod-splide-arrow',
						prev: 'splide__arrow--prev mod-splide-prev',
						next: 'splide__arrow--next mod-splide-next',
					},
				});
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.mount();
			});
		},
		slider03() {
			const splideEls = document.querySelectorAll('.js-slider03');
			splideEls.forEach(slide => {
				const splide = new Splide(slide, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 1,
					perMove: 1,
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: true,
					classes: {
						arrows: 'splide__arrows mod-splide-arrows',
						arrow: 'splide__arrow mod-splide-arrow',
						prev: 'splide__arrow--prev mod-splide-prev',
						next: 'splide__arrow--next mod-splide-next',
						pagination: 'splide__pagination mod-splide-pagination',
						page: 'splide__pagination__page mod-splide-pagination-page',
					},
				});
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.mount();
			});
		},
		logoLoopSlider() {
			const splides = document.querySelectorAll('.js-logoLoopSlider');
			const _this = this;
			splides.forEach(slideElement => {
				// data-reverse属性で反転タイプを判定
				const isReverse = slideElement.dataset.reverse === "true";
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoWidth: true,
					gap: '8px',
					pauseOnHover: false,
					pauseOnFocus: false,
					arrows: false,
					pagination: false,
					direction: isReverse ? 'rtl' : 'ltr',
					drag: false,
					pauseOnHover: false,
					pauseOnFocus: false,
					autoScroll: {
						speed: .8,
						pauseOnHover: false,
						pauseOnFocus: false,
					}
				});
				splide.mount(window.splide.Extensions);
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.inViewAnimation2();
			_this.nextToggle();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.URLcurrentHidden();
			_this.URLcurrentDirectory3Hidden();
			_this.URLcurrentDirectory4Hidden();
			_this.headerMegamenu();
			_this.headerCurrent();
			_this.headerHamburger();
			_this.scrollHint();
			_this.topicsSlider();
			_this.slider01();
			_this.slider02();
			_this.slider03();
			_this.logoLoopSlider();
			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();